module.exports = __webpack_public_path__ + "img/tn-map.8c6321d2.svg";